<style lang="sass" scoped>
.wrong
  color: red !important
input
  padding-left: 0 !important

.disabled_input
  color: rgba(51, 68, 85, 0.45) !important
</style>

<template>
  <div class="container">
    <input
      :name="name"
      :maxlength="maxlength"
      :value="value"
      class="input"
      :autocomplete="autocomplete"
      :onkeypress="type ==='number' ? 'return event.keyCode>=48&&event.keyCode<=57' : ''"
      :disabled="disabled"
      :placeholder="placeholder"
      :required="required"
      :style="{ 'background-color': backgroundColor}"
      :class="{'disabled_input': disabled }"
      type="text"
      :inputmode="type === 'number' ? 'numeric' : null"
      @focus="handleFocus"
      @blur="onBlur"
      @input="handleInput"
    />
    <div class="bar" :style="{ color: color }"></div>
    <label
      v-if="enableFloat"
      class="label"
      :class="{ 'push-from-bottom': push_from_bottom || value, 'wrong': !rePass }"
      :style="{ color: push_from_bottom ? color : 'rgba(0, 0, 0, 0.6)' }"
    >{{ label }}</label>
    <label
      v-else
      class="label"
      :class="{ 'push-from-bottom': true, 'wrong': !rePass }"
      :style="{ color: push_from_bottom ? color : 'rgba(0, 0, 0, 0.6)', width : titleWidth }"
    >{{ label }}</label>
  </div>
</template>

<script>
export default {
  inject: {
    itemPass: {
      default: {
        pass: true
      }
    }
  },

  name: 'VueMaterialInputBox',

  props: {
    name: {
      type: String
    },

    maxlength: {
      type: String,
      default: '19'
    },

    value: {
      type: [String, Number]
    },

    autocomplete: {
      default: 'off',
      type: String,
    },

    backgroundColor: {
      default: '#FAFAFA',
      type: String,
    },

    color: {
      default: '#2196F3',
      type: String,
    },

    disabled: {
      default: false,
      type: Boolean,
    },

    label: {
      default: null,
      type: String,
    },

    placeholder: {
      default: null,
      type: String,
    },

    required: {
      default: false,
      type: Boolean,
    },

    type: {
      default: 'text',
      type: String,
    },

    enableFloat: {
      type: Boolean,
      default: true
    },

    titleWidth: {
      type: String,
    }
  },

  data() {
    return {
      push_from_bottom: false,
    }
  },

  computed: {
    rePass() {
      return this.itemPass.pass
    }
  },

  created() {
    if (this.placeholder) this.push_from_bottom = true
  },

  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value)
    },

    onBlur(event) {
      this.$emit('pyBlur', event.target.value)
      if (!this.value && !this.placeholder) this.push_from_bottom = false
    },

    handleFocus(event) {
      this.push_from_bottom = true
      this.$emit('focus', event)
    }
  },
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
}

.input {
  padding: 10px 15px 10px 5px;
  display: block;
  border: none;
  border-bottom: 2px solid #d4d4d4;
  color: rgba(0, 0, 0, 0.87);
  width: 100%;
}

.input:focus {
  border-bottom: none;
  outline: none;
}

.bar:before,
.bar:after {
  background-color: currentColor;
  content: '';
  height: 2px;
  position: absolute;
  transition: all ease 0.3s;
  width: 0;
}

.bar:before {
  left: 50%;
}

.bar:after {
  right: 50%;
}

.input:focus ~ .bar:before,
.input:focus ~ .bar:after {
  width: 50%;
}

.label {
  bottom: 10px;
  font-size: 17px;
  pointer-events: none;
  position: absolute;
  transition: all ease 0.3s;
}

.push-from-bottom {
  bottom: 45px;
  font-size: 14px;
}

.push-from-bottom {
  bottom: 45px;
  font-size: 14px;
}
</style>